import React from "react";

import classes from "./SmallNavigation.module.css";
import HomeIcon from "../../../assets/svg/Seller/HomeIcon.svg";
import ActivityIcon from "../../../assets/svg/Seller/ActivityIcon.svg";
import MesssageIcon from "../../../assets/svg/Seller/MessageIcon.svg";
import ProfileIcon from "../../../assets/svg/Seller/ProfileIcon.svg";
import LogoutIcon from "../../../assets/svg/Seller/LogoutIcon.svg";
import { useHistory } from "react-router-dom";

const SmallNavigation = (props) => {
  const history = useHistory();
  return (
    <div className={classes.SmallNavigation}>
      <p className={classes.NavItem} onClick={(event) => history.push("/")}>
        <img src={HomeIcon} alt="Home" />
        <span className="d-none d-sm-block ms-1">Home</span>
      </p>
      <p
        className={classes.NavItem}
        onClick={(event) => history.push("/Activites")}
      >
        <img src={ActivityIcon} alt="Activity" />
        <span className="d-none d-sm-block ms-1">Activity</span>
      </p>
      <p
        className={classes.NavItem}
        onClick={(event) => history.push("/Messages")}
      >
        <img src={MesssageIcon} alt="Messsage" />
        <span className="d-none d-sm-block ms-1">Messages</span>
      </p>
      <p
        className={classes.NavItem}
        onClick={(event) => history.push("/Profile")}
      >
        <img src={ProfileIcon} alt="Profile" />
        <span className="d-none d-sm-block ms-1">Profile</span>
      </p>
      <p
        className={classes.NavItem}
        onClick={(event) => {
          props.onlogOut();
        }}
      >
        <img src={LogoutIcon} alt="LogOut" />
        <span className="d-none d-sm-block ms-1">LogOut</span>
      </p>
    </div>
  );
};

export default SmallNavigation;
